<!--
 * @Author: yaoyuting
 * @Date: 2021-04-11 18:24:56
 * @LastEditors: yaoyuting
 * @LastEditTime: 2021-05-19 19:49:54
 * @Descripttion:
-->
<template>
    <div class="Blog">
        <div class="title">
            <div class="BigTitle">{{ $t("Blog.title") }}</div>
            <div class="line"></div>
        </div>
        <div class="box-card">
            <!--      <van-list  class="item"-->
            <!--                 v-model="loading"-->
            <!--                 :finished="finished"-->
            <!--                 finished-text="没有更多了"-->
            <!--                 @load="onLoad"-->
            <!--      >-->
            <!--        <van-cell v-for="item in list" :key="item" :title="item" />-->

            <!--      </van-list>-->
            <div class="item infinite-list-item"  v-for="blog in blogList"  :key="blog.blogId">
                <router-link :to="{ path: '/m/BlogDetail', query: { id: blog.blogId } }">
                    <div class="hover-item">
                        <img :src="blog.images"/>
                        <div class="introT">{{blog.blogTitle }}</div>
                        <div class="introD"  v-html="blog.text"></div>
                        <div class="time">{{ blog.createTime }}</div>
                    </div>
                </router-link>

            </div>
            <div class="bu-bottom"  @click="more">
                <div class="button" >{{ $t("Blog.more") }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        GetBlogList,
    } from '@/assets/server/api.js';
    import {trimHtml, formatDateStr } from "@/utils/utils";
    import { List, Toast } from 'vant';
    export default {
        components: {
            List,
            Toast
        },
        data() {
            return {
                blogList: [],
                dialogVisible: false,
                email: '',
                pageSize: 1,//第几页
                total: 0,
                monthEnglish:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Spt","Oct","Nov","Dec"],
                time: '',
                isShow: true,
                num: 0,//计数页面请求了多少条
                list: [],
                loading: false,
                finished: false
            };
        },
        created() {
          //  this.getBlogList();
            this.num = 5;
        },
        destroyed() {
        },
        //在需要缓存的页面加两个钩子beforeRouteEnter，activated
        // beforeRouteEnter(to, from, next) {
        //     let path = from.path;
        //     //判断需要定位的路由地址
        //     if(path == '/m/BlogDetail'){
        //         to.meta.isBack = true;//是否返回的判断依据改为true
        //         //获取储存起来的位置
        //         let scrollTop = sessionStorage.getItem("scrollTop");
        //         if(scrollTop){
        //             setTimeout(()=>{
        //                 window.scrollTo(0,scrollTop*1);
        //                 sessionStorage.setItem('scrollTop',0);   //定位后还原储存位置信息
        //             },100)
        //         }
        //     }
        //     next();
        // },
        //activated会在history模式时正常执行
        // activated() {
        //     //非从详情页返回时正常加载数据
        //     if (!this.$route.meta.isBack) {
        //         this.getBlogList();//执行加载数据的方法
        //         this.num = 5;
        //     }
        //     //执行完初始化isBack
        //     this.$route.meta.isBack = false
        // },
        // beforeRouteLeave(to,from,next){
        //     if(to.path=='/m/BlogDetail'){
        //         sessionStorage.setItem('scrollTop', document.documentElement.scrollTop);
        //     }
        //     next();
        // },
        methods: {
            /* onLoad() {
              // 异步更新数据
              // setTimeout 仅做示例，真实场景中一般为 ajax 请求
              setTimeout(() => {
                for (let i = 0; i < 10; i++) {
                  this.list.push(this.list.length + 1);
                }

                // 加载状态结束
                this.loading = false;

                // 数据全部加载完成
                if (this.list.length >= 40) {
                  this.finished = true;
                }
              }, 1000);
            }, */
            more() {
                if(this.num>=this.total){
                    Toast('No further data');
                    return;
                }
                this.pageSize++;
                this.num += 5;
                // this.isShow = !this.isShow;
                this.getBlogList();
                this.num = this.isShow ? this.num : this.total;

                // this.blogList += this.getBlogList();
                // console.log(this.blogList.);
                // this.txt = this.isShow?  '显示全部':'收起'

            },
            async getBlogList() {
                const data = await GetBlogList({
                    pageNo: this.pageSize,
                    pageSize: 5,
                });
                if (data.code === 0) {
                    let rows = data.rows;
                    rows.forEach((item) => {
                        item.text = trimHtml(item.text);
                        //createTime格式: 2022-03-25 10:03:59
                        // ios端浏览器日期格式化有兼容性问题,要转换成2022/03/25 10:03:59
                        let date = new Date(formatDateStr(item.createTime));
                        let month = this.monthEnglish[date.getMonth()];
                        let day = date.getDate();
                        item.createTime = month +' '+ day;
                    });
                    this.total = data.total;
                    if(this.pageSize==1){
                        this.blogList = rows;
                    }else{
                        this.blogList = this.blogList.concat(rows);
                    }
                    // this.blogList = this.blogList.concat(rows);
                } else {
                    this.$message.error(data.msg);
                }
            },
            getTimeStamp(date){
                //current time
                let days ="";
                let timestamp = parseInt(Date.parse(new Date()) / 1000);
                let strdate = parseInt(Date.parse(date)/ 1000);
                let s = timestamp - strdate; //9.20
                let fenzhong = parseInt((s / 86400) * 24 * 60);
                // console.log(fenzhong);
                if (fenzhong < 60) {
                    if (fenzhong == 0) {
                        days = "just now read";
                    } else {
                        days = parseInt(fenzhong) + "min read";
                    }
                }
                if (fenzhong >= 60 && fenzhong <= 1440) {
                    days = parseInt(fenzhong / 60) + "hour read";
                }
                if (fenzhong > 1440) {
                    days = parseInt(fenzhong / 1440) + "day read";
                }
                return days;
            },
        },
    };
</script>

<style lang="less" scoped>
    .Blog {
        text-align: center;
        margin-top: 110px;
        margin-bottom: 401px;
        width: 100%;
        color: #000000;

    .title {
        text-align: center;
        height: 761px;
        background: url("../../../assets/m/intro/bgi.png") no-repeat center/100%
        100%;
    .BigTitle{
        padding-top: 120px;
        font-size: 64px;
        font-weight: 900;
        color: #000000;
        line-height: 83px;
        margin-bottom: 60px;
    }
    .line{
        margin: 0 auto;
        width: 670px;
        height: 0px;
        opacity: 1;
        border: 2px solid #EBEBEB;
    }
    }
    .vant-list {
        width: 650px;
        height: 200px;
    }
    .box-card {
        margin-top: -498px;
        text-align: center;
    .item {
        cursor: pointer;
        width: 650px;
        margin: 0 auto;
        text-align: left;
        padding-bottom: 61px;
    img {
        margin-top: 60px;
        width: 650px;
        height: 445px;
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
    }
    .introT {
        font-size: 32px;
        font-weight: bold;
        color: #1A1A2C;
        font-family: Poppins-Bold, Poppins;
        line-height: 54px;
        margin-top: 20px;
        word-wrap: break-word;
    }
    .introD {
        height: 138px;
        font-size: 28px;
        font-weight: 400;
        color: #737582;
        line-height: 46px;
        margin-top: 10px;
        margin-bottom: 20px;
        font-family: PingFang SC-Regular, PingFang SC;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        display: -webkit-box;
        word-wrap: break-word;
        /*-webkit-box-orient: vertical;*/
        /*-webkit-line-clamp: 3;*/
        /*overflow: hidden;*/
    }
    .time{
        font-size: 20px;
        font-family: Ubuntu-Regular, Ubuntu;
        font-weight: 400;
        color: #4573E7;
        line-height: 42px;
        letter-spacing: 1px;
        width: 120px;
        height: 42px;
        background: rgba(50, 120, 255, 0.05);
        border-radius: 0px 0px 0px 0px;
        text-align: center;
    }
    }
    .bu-bottom{
        margin-top: 89px;
    }
    .button{
        width: 260px;
        height: 100px;
        margin: 0 auto;
        background: #FFFFFF;
        border-radius: 14px 14px 14px 14px;
        opacity: 1;
        border: 2px solid #4573E7;
        font-size: 30px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4573E7;
        line-height: 100px;
        letter-spacing: 1px;
    }
    }
    }
</style>
